var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import ProspectSourceCategoryService from "../../../Services/ProspectSourceCategory.service";
import ProspectSourceCategoryLookupModal from "./ProspectSourceCategoryLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield ProspectSourceCategoryService.search({
            ids: options.ids,
            names: options.names,
            query: search,
        }, { max: (_a = options.max) !== null && _a !== void 0 ? _a : 20 });
        return response.data;
    }),
    value: "id",
    label: "name",
};
export const ProspectSourceCategorySearch = makeSearch(makeSearchArgs);
export const ProspectSourceCategoryMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error I think I found a fix for this, waiting on Dan's feedback
    lookupModal: ProspectSourceCategoryLookupModal }));
